export { EdpDiscountFormComponent } from "./edp-discount-form.component";
